import {Button, Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import {Icon} from "@iconify/react";
import {useContext} from "react";
import {CompanyContext, CompanyContextValue} from "../context/companyContext";

const SuccessfullSolicitation = () => {
    const navigate = useNavigate()
    const {clientSolicitationId} = useContext<CompanyContextValue>(CompanyContext)
    
    return (
        <Grid container spacing={1} justifyContent={'center'}>
            <Grid item xs={12}>
                <Typography fontSize={22} fontWeight={700} textAlign={'center'}>Su solicitud fue creada exitosamente.</Typography>
            </Grid>
            <Grid item xs={10} mb={3}>
                <Typography fontSize={17} fontWeight={500} textAlign={'center'} color={'#A1A5B7 !important'}>
                    {`Su solicitud fue registrada de manera exitosa en nuestra base de datos bajo el ID: #${clientSolicitationId}. En los próximos días recibirá un mail a su casilla
                    de correo electrónico con las etapas que la susodicha atraviesa. Ante cualquier consulta, consulte a comercial@fogaba.com`}
                </Typography>
            </Grid>
            <Grid item xs={12} textAlign={'center'}>
                <CheckCircleRoundedIcon sx={{
                    userSelect: 'none',
                    width: '1em',
                    height: '1em',
                    display: 'inline-block',
                    flexShrink: 0,
                    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    fontSize: '120px',
                    marginBottom: '16px'
                }} 
                                        color='success'
                />
            </Grid>
            <Grid item xs={12} textAlign={'center'} mt={1}>
                <Button variant='contained' color='primary' onClick={() => navigate('/solicitudes')} endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}>
                    Volver al inicio
                </Button>
            </Grid>
        </Grid>
    )
}


export default SuccessfullSolicitation